export default {
    default: {
        fetchModelsPeriod: 30000, // définit le temps en ms entre chaque fetch
    },
    listModels: {
        users: {
            url: 'user/',
            verboseName: 'Users',
        },
        groups: {
            url: 'group/',
            verboseName: 'Groups',
        },
        bases: {
            url: 'base/',
            verboseName: 'Bases',
        },
        alerts: {
            url: 'alert/',
            verboseName: 'Alerts',
            fetch: false,
        },
        alarm: {
            url: 'alarm/',
            verboseName: 'Alarm',
        },
        kpi: {
            url: 'kpi/',
        },
        inspectionRequests: {
            url: 'inspection-request/',
            verboseName: 'Inspection Requests',
            filter: { archived: false },
            fetch: false,
        },
        vehicles: {
            url: 'vehicle/',
            verboseName: 'Vehicles',
            filter: { out_of_fleet: false },
            fetch: false,
        },
        inspectionRequestLogs: {
            url: 'inspection-request-log/',
            verboseName: 'Inspection Request Logs',
            fetch: false,
        },
        generalParameters: {
            url: 'general-parameter/',
            verboseName: 'General Parameter',
            filter: { key: "LAST_JOB_INPUT_FILE_DATETIME" },
        },
        exportGenerationRequests: {
            url: 'export-generation-request/',
            verboseName: 'Export Generation Requests',
            fetch: false,
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/meta.js